import React from "react"
import { Page } from "react-onsenui";
import styles from './index.module.css'
import inlineStyles from "./inlineStyles";
import { IconCheck } from "@tabler/icons-react";
import { useShowValidationResult } from "./useShowValidationResult";

const ValidTicketResult = (props) => {

    const {scan, onClickNext} = props
    const {setShowValidationResult} = useShowValidationResult()

    return (
        <>
            {scan &&
                <Page contentStyle={inlineStyles.modalBody} class={styles.valid}>

                    <div className={styles.card}>
                        <div className={styles.eventName}>
                            {scan.event_name}
                        </div>

                        {scan.product_variant_title &&
                            <div className={styles.variantTitle}>
                                {scan.product_variant_title}
                            </div>
                        }

                        <div className={styles.indicator}>
                            <IconCheck size={70}/>
                        </div>

                        <div className={styles.ticket}>
                            Valid Ticket
                        </div>

                        <div className={styles.code}>
                            {scan.qr_data}
                        </div>
                    </div>

                    <button
                        className={styles.nextButton}
                        onClick={() => {
                            setShowValidationResult(false)
                            onClickNext()
                        }}
                    >
                        Next
                    </button>

                </Page>
            }
        </>
    )
}

export default ValidTicketResult
